export const MARKETING_BASENAME = "/sales";
